var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vgsi__panel" }, [
    _c("div", { staticClass: "vgsi__panel-top" }, [
      _c("div", { staticClass: "vgsi__panel-indicator" }, [
        _c("div", { staticClass: "vgsi__panel-current" }, [
          _vm._v(_vm._s(_vm.current.number + 1))
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vgsi__panel-indicator-label" }, [
        _c("h4", [_vm._v(_vm._s(_vm.current.label))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vgsi__panel-body" }, [
      _c("div", { staticClass: "vgsi__panel-buttons" }, [
        _c(
          "div",
          { staticClass: "vgsi__panel-buttons__top" },
          _vm._l(_vm.solutions, function(item, index) {
            return _c(
              "Button",
              {
                key: index,
                class: [
                  { "is-current": index === _vm.current.number ? true : false },
                  "btn-" + index
                ],
                attrs: {
                  "prop-button-label":
                    item.panel_label !== ""
                      ? item.panel_label
                      : item.slide_title
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.clickHandle(index)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vgsi__panel-buttons__bottom" },
          [
            _vm.hotline
              ? _c(
                  "Button",
                  {
                    staticClass: "is-hotline has-svg-icon",
                    attrs: { "prop-button-label": _vm.hotline.text },
                    nativeOn: {
                      click: function($event) {
                        return _vm.clickContactHandle()
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          "enable-background": "new 0 0 480.56 480.56",
                          version: "1.1",
                          viewBox: "0 0 480.56 480.56",
                          "xml:space": "preserve",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "m365.35 317.9c-15.7-15.5-35.3-15.5-50.9 0-11.9 11.8-23.8 23.6-35.5 35.6-3.2 3.3-5.9 4-9.8 1.8-7.7-4.2-15.9-7.6-23.3-12.2-34.5-21.7-63.4-49.6-89-81-12.7-15.6-24-32.3-31.9-51.1-1.6-3.8-1.3-6.3 1.8-9.4 11.9-11.5 23.5-23.3 35.2-35.1 16.3-16.4 16.3-35.6-0.1-52.1-9.3-9.4-18.6-18.6-27.9-28-9.6-9.6-19.1-19.3-28.8-28.8-15.7-15.3-35.3-15.3-50.9 0.1-12 11.8-23.5 23.9-35.7 35.5-11.3 10.7-17 23.8-18.2 39.1-1.9 24.9 4.2 48.4 12.8 71.3 17.6 47.4 44.4 89.5 76.9 128.1 43.9 52.2 96.3 93.5 157.6 123.3 27.6 13.4 56.2 23.7 87.3 25.4 21.4 1.2 40-4.2 54.9-20.9 10.2-11.4 21.7-21.8 32.5-32.7 16-16.2 16.1-35.8 0.2-51.8-19-19.1-38.1-38.1-57.2-57.1z"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "m346.25 238.2 36.9-6.3c-5.8-33.9-21.8-64.6-46.1-89-25.7-25.7-58.2-41.9-94-46.9l-5.2 37.1c27.7 3.9 52.9 16.4 72.8 36.3 18.8 18.8 31.1 42.6 35.6 68.8z"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "m403.95 77.8c-42.6-42.6-96.5-69.5-156-77.8l-5.2 37.1c51.4 7.2 98 30.5 134.8 67.2 34.9 34.9 57.8 79 66.1 127.5l36.9-6.3c-9.7-56.2-36.2-107.2-76.6-147.7z"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.more
              ? _c(
                  "Button",
                  {
                    staticClass: "is-more has-svg-icon",
                    attrs: { "prop-button-label": _vm.more.text }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 23 14",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            transform: "translate(0 14) rotate(-90)",
                            d: "M7,0l7,9H0Z",
                            fill: "#333"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            transform: "translate(23) rotate(90)",
                            d: "M7,0l7,9H0Z",
                            fill: "#333"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vgsi__panel-direction" }, [
      _c("span", { staticClass: "arrow-up" }),
      _vm._v(" "),
      _c("span", { staticClass: "arrow-down" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }